import React from 'react';
import { FolderOpen } from 'lucide-react';

/**
 * Compliance banner shown on every page where a user can generate a
 * field-report PDF. Reminds office staff that the PDF is not retained
 * on the server — they must save it locally / to their own filing system.
 */
export default function PdfStorageNotice({ className = '' }) {
  return (
    <div
      className={`flex items-start gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-md text-sm text-amber-800 ${className}`}
      data-testid="pdf-storage-notice"
    >
      <FolderOpen className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-600" aria-hidden="true" />
      <p className="leading-snug">
        Save this PDF to OneDrive or your filing system. It will not be saved automatically.
      </p>
    </div>
  );
}
